import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
function Slide({imgURL,inputText}){
    console.log(imgURL);
    return (
        <Wrapper Img={imgURL}>
        <Wrapper_span>{inputText}</Wrapper_span>   
        </Wrapper>
    )
}  
const Wrapper_top = styled.img`
    position : absolute;
    background : white;
    width : 1200px;
    height : 300px;
`
const Wrapper_span = styled.span`
font-family: "En";        
position : relative;
width : 300px;
left :400px;
top : 130px;
font-size : 30px;
font-weight : bold;
`
const Wrapper = styled.div`
width : 1200px;
height : 300px;
margin : 0 auto;
background-image: url(${props=>{return props.Img}});
background-size :1200px 300px;
`
export default Slide;